import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxLoadersCssComponent } from './ngx-loaders-css.component';

@NgModule({
  imports: [CommonModule],
  declarations: [NgxLoadersCssComponent],
  exports: [NgxLoadersCssComponent],
})
export class NgxLoadersCssModule {}
